module.exports = __webpack_public_path__ + "img/search.380ecba3.svg";